import { CLOSE_PANIER, OPEN_PANIER, PanierActionTypes } from '../types';

export function openPanier(): PanierActionTypes {
	return { type: OPEN_PANIER };
}

export function closePanier(): PanierActionTypes {
	return { type: CLOSE_PANIER };
}
